import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Bill from '../components/bill/index';
import * as BillAction from '../actions/billAction';
function mapStateToProps(state) {
  return {
    currentBalance: state.Bill.currentBalance,
    verAccDetails: state.Bill.verAccDetails,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...BillAction,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Bill);
